export default __webpack_public_path__ + "static/media/Logo-JR.163667af.jpg";